<template>
    <section class="main" style="position: relative; margin: 0 auto" :style="{'background-color': block.color, 'padding-top': block.paddingTop + 'px', 'padding-bottom': block.paddingBottom + 'px'}">

        <v-container >
            <v-row v-for="(item, index) in block.points" :key="index" justify="center" style="max-width: 1200px; margin: 0 auto">
                <v-col :cols="cols">
                    <div class="point" style="position: relative">
                        <div class="index-container">

                            <img  v-if="item.img" :src="item.img" style="width:70px;height: 70px">
                            <div v-else class="circle-index">{{index + 1}}</div>
                        </div>
                        <div class="text-container">
<!--                            <div class="title" contenteditable="true" ref="title" @input="updateTitle(index)"></div>-->
                            <div class="title" v-html="item.title"></div>
                            <div class="description" v-html="item.description"></div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>

    </section>
</template>

<script>

    export default {
        props:["block", "del"],
        name: "ListBlock",
        data(){
            return{
            }
        },
        computed: {
            cols() {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs':
                        return 12
                    case 'sm':
                        return 12
                    case 'md':
                        return 8
                    case 'lg':
                        return 8
                    case 'xl':
                        return 8
                }
                return false
            }
        },
        methods:{
        }
    }
</script>

<style scoped>
    .point{
        display: flex;
    }

    .point .index-container .circle-index{
        width: 70px;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #dc7d43;
        color: #18224b;
        border: 3px solid #18224b;
        line-height: 70px;
        font-size: 30px;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        border-radius: 50%;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
    }

    .point .text-container{
        box-sizing: border-box;
        padding-left: 40px;
        flex: 1;
    }

    .point .text-container .title{
        width: 100%
    }

    .point .text-container .description{
        width: 100%
    }

    .hovered{
        opacity: 0;
        transition: 0.3s;
    }

    .main:hover .hovered{
        opacity: 1;
    }

    .close-btn{
        opacity: 0;
        transition: 0.3s;
    }

    .point:hover .close-btn{
        opacity: 1;
    }


</style>